
export const APP_PATH = 'admin_api'
export const COMMON_PATH = 'common'
//auth
export const LOGIN = "/auth/login";
export const LOGOUT = "/auth/logout";
//profile
export const PROFILE = "/auth/profile";
export const UPDATE_PROFILE = "/auth/edit_profile";
export const CHANGE_PASSWORD = "/auth/change_password";
export const FORGOT_PASSWORD = "/auth/forgot_password";
//reset password
export const RESET_PASSWORD_FORM = "/auth/reset_password_form/";
export const RESET_PASSWORD = "/auth/reset_password";

//file
export const UPLOAD_IMAGE_PATH = "/upload_image";
export const DELETE_IMAGE_PATH = "/delete_image";
//dashboard
export const GET_DASHBOARD_ = "/auth/dashboard";

//system access
export const GET_ACCESS_LIST = "/admin/getAllUsers";
export const ADD_ACCESS = "/admin/addUser";
export const UPDATE_ACCESS = "/admin/updateUser";
export const DELETE_ACCESS = "/admin/deleteUser";
export const GET_ACCESS_DETAIL = "/admin/getUserDetails";
//cms
export const GET_CMS_LIST = "/page/list";
export const UPDATE_CMS = "/page/edit/";
export const VIEW_CMS_DETAIL = "/page/view/";
//faq
export const GET_FAQ = "/faq/list";
export const ADD_FAQ = "/faq/add";
export const UPDATE_FAQ = "/faq/edit";
export const VIEW_FAQ = "/faq/view/";
export const DELETE_FAQ = "/faq/delete/";
export const UPDATE_STATUS_FAQ = "/faq/update_status/";